module.exports = __webpack_public_path__ + "img/dialogbg.ac126402.png";